import { NumberField } from "./NumberField";
import { statsFor } from "../../lib/shield";

export const StatsPanel = ({ stats, sport, onChange }) => (
  <div className="space-y-3">
    <p className="text-sm text-slate-600">Enter whole numbers from <b>0 to 100</b>. Leave a field empty if you don't have a value yet.</p>
    <div className="grid grid-cols-1 gap-x-5 gap-y-2 sm:grid-cols-2">
      {[0, 3].map((start) => (
        <div key={start} className="space-y-2">
          {statsFor(sport).slice(start, start + 3).map((s) => (
            <NumberField key={s.key} id={`stat-${s.key}`} label={`${s.label} (${s.key}):`} value={stats[s.key]}
              onCommit={(v) => onChange({ ...stats, [s.key]: v })} testId={`stat-input-${s.key}`} />
          ))}
        </div>
      ))}
    </div>
  </div>
);
